export default __webpack_public_path__ + "static/media/Power_AFąfaraIskra.180b1342.pdf";